import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';
import Link from 'next/link';
import { BiChevronRight } from 'react-icons/bi';

const WooCommerceSchnittstelleCTA = () => {
    const { t } = useTranslations();

    return (
        <section className="wc-cta pt-100 pb-100">
            <div className="wc-cta__decoration"></div>

            <div className="container wc-cta__content">
                <div className="row">
                    <div className="col-12">
                        <FadeInAnimation direction="up" delay={50}>
                            <div className="wc-cta__box">
                                <h2 className="wc-cta__title">
                                    {t('woocommerceSchnittstelle_cta_title')}
                                </h2>
                                <p className="wc-cta__description">
                                    {t('woocommerceSchnittstelle_cta_description')}
                                </p>
                                <div className="wc-cta__buttons">
                                    <Link href="/kontakt" className="wc-cta__btn-primary">
                                        {t('woocommerceSchnittstelle_cta_button')}
                                        <BiChevronRight />
                                    </Link>
                                    <a href="#pricing" className="wc-cta__btn-secondary">
                                        {t('woocommerceSchnittstelle_cta_button2')}
                                    </a>
                                </div>
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WooCommerceSchnittstelleCTA;
